/* @flow */

import * as React from "react";
import cn from "classnames";

import styles from "./styles.scss";

type Props = {
  className?: string,
  children: React.Node,
};

export const Items = ({ children, className = "", ...props }: Props): React$Node => {
  return (
    <div {...props} className={cn(styles.items, className)}>
      {children}
    </div>
  );
};
